import React, { FC } from 'react';
import { SectionHeader, SectionHeaderProps } from '@components/molecules/SectionHeader';
import { Container } from '@components/atoms/Container';
import { ServiceCard, ServiceCardProps } from '../ServiceCard';
import { Space } from '@components/atoms/Space';
import { TypographyAppearanceVariants } from '@components/atoms/Typography';

export interface ServicesHighlightsProps extends Omit<SectionHeaderProps, 'title'> {
    title: string;
    services: ServiceCardProps[];
}

const MAX_SERVICES = 3;

export const ServicesHighlights: FC<ServicesHighlightsProps> = ({
    overline,
    title,
    description,
    actionLabel,
    linkTo,
    services,
}) => {
    const seeMore = services.length >= MAX_SERVICES;

    return (
        <div data-testid="services-highlights">
            <Container>
                <SectionHeader
                    overline={overline}
                    title={{ text: title, level: TypographyAppearanceVariants.level2 }}
                    description={description}
                    actionLabel={seeMore ? actionLabel : undefined}
                    linkTo={seeMore ? linkTo : undefined}
                />
            </Container>

            <Space spaceBreakpoints={{ xs: { space: 50 } }} />

            {/* list of services */}
            <Container>
                <div className="row row-gap-4 pt-2">
                    {services.slice(0, MAX_SERVICES).map((service, index) => (
                        <div key={`service-${index}`} className="col-12 col-lg-4 col-xxl-4">
                            <ServiceCard {...service} />
                        </div>
                    ))}
                </div>
            </Container>
        </div>
    );
};
